import avatarModule from '../avatarModule';

function round() {
  'ngInject';

  return function(input, increment) {
    return increment * Math.round(input / increment);
  };
}

avatarModule.filter('round', round);
